import { Dialog, DialogContent, IconButton, withStyles } from "@material-ui/core";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import React from "react";
import AlertBox from "../../../shared/AlertBox";
import { regularInputClass } from "../../../../styles/styles";
import { updateCustomerType } from "../../../../networking/NetworkingCustomers";

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
})

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    )
})

export default class UpdateCustomerTypeDialog extends React.Component {
    state = {
        title: "Update Customer Type",
        subTitle: "Other Customer Type:",
        otherType: "",
        propertyDescription: "",
        lookUpDescription: "",

        showAlert: false,
        alertMessage: '',
        alertTitle: '',
        
        showAlertYesNo: false,
        alertMessageYesNo: '',
        alertTitleYesNo: '',

        saved: false
    }

    async componentDidUpdate(prevProps) {
        if(this.props !== prevProps) {
            this.setState({propertyDescription: this.props.propertyDescription, 
                            lookUpDescription: this.props.lookUpDescription, 
                            subTitle: this.props.type,
                            title: this.props.title});
        }
    }

    componentDidMount(){
        this.setState({propertyDescription: this.props.propertyDescription, 
                            lookUpDescription: this.props.lookUpDescription, 
                            subTitle: this.props.type,
                            title: this.props.title});
    }

    onCloseDialog = () => {
        this.setState({}, () => this.props.onClose(this.state.saved, this.state.otherType));
    }

    handleUpdateOtherType = async () => {
        if(this.state.otherType !== '' && this.state.otherType !== null){
            let model = {
                CustomerID: this.props.customerId,
                CustomerType: this.state.otherType,
                PropertyDescription: this.state.propertyDescription,
                LookUpDescription: this.state.lookUpDescription,
                UserId: localStorage.getItem('UserID')
            }
            let jsonResponse = await updateCustomerType(model);
            if(jsonResponse !== undefined){
                if(jsonResponse.httpStatusCode === 200 && jsonResponse.response){
                    this.setState({showAlert: true, alertTitle: 'Success', alertMessage: this.state.type + ' successfully updated.', saved: true})
                } else {
                    this.setState({showAlert: true, alertTitle: 'Warning', alertMessage: 'The ' + this.state.type + ' you entered already exists. Please try again later.'})
                }
            }
            else {
                this.setState({showAlert: true, alertTitle: 'Error', alertMessage: 'Something went wrong. Please try again later.'})
            }
        }
    }

    handleOtherType = (event) => {
        this.setState({otherType: event.target.value});
    }

    //alerts
    closeAlert = () => {
        this.setState({showAlert: false, alertMessage: '', alertTitle: ''})
    }
    closeAlertYesNo = () => {
        this.setState({showAlertYesNo: false, alertMessageYesNo: '', alertTitleYesNo: ''})
    }

    render() {
        return(
            <Dialog
                open        = {this.props.open} 
                onClose     = {this.props.onClose}
                fullWidth   = {true}
                maxWidth    = {false}
                style       = {{
                    width: '30%',
                    margin: 'auto',
                    minWidth: '400px'
                }}
            >
                <DialogTitle
                    id="update-customer-type-dialog-title"
                    onClose={this.onCloseDialog}
                >
                    {this.state.title}
                </DialogTitle>
                <DialogContent dividers style={{paddingLeft:24, overflowY: 'visible'}}>
                    <div className="uk-grid">
                        <div className="uk-width-1-1">
                            <label className="uk-form-label">{'Other ' + this.state.subTitle}</label>
                            <input 
                                className   = {regularInputClass}
                                type        = "text" 
                                id          = "form-update-customer-type-type" 
                                value       = {this.state.otherType} 
                                onChange    = {this.handleOtherType}/>
                        </div>
                        <div className="uk-width-1-1" style={{paddingTop: 20, marginBottom:0}}>
                            <button 
                                className   = "uk-button uk-button-default uk-button-green" 
                                type        = "button" 
                                onClick     = {this.handleUpdateOtherType}
                            >{this.state.title}</button>
                            <button 
                                className="uk-button uk-button-green uk-float-right" 
                                type="button" 
                                onClick={this.onCloseDialog}
                            >close</button>
                        </div>
                    </div>
                </DialogContent>
                
                <AlertBox
                    open    = {this.state.showAlert} 
                    onClose = {this.closeAlert} 
                    type    = "Ok" 
                    title   = {this.state.alertTitle} 
                    message = {this.state.alertMessage} 
                    okClick = {this.closeAlert}
                />
                <AlertBox
                    open    = {this.state.showAlertYesNo} 
                    onClose = {this.closeAlertYesNo} 
                    type    = "Yes/No" 
                    title   = {this.state.alertTitleYesNo} 
                    message = {this.state.alertMessageYesNo} 
                    noClick = {this.closeAlertYesNo} 
                    yesClick= {this.handleUpdateCustomerType}
                />
            </Dialog>
        )
    }
}